export class ForgotPasswordModel {
    public email: string;
    public id: string;
}
